export default __webpack_public_path__ + "static/media/BackLine3.761d93ff.svg";